import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Public Pages
import Home from './pages/Home';
import EventDetails from './pages/EventDetails';
import BookingSuccess from './pages/BookingSuccess';
import BookingCancel from './pages/BookingCancel';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import GeneralRules from './pages/GeneralRules';
import InviteRedeem from './pages/InviteRedeem';

// Admin Auth Pages
import AdminLogin from './pages/AdminLogin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// Admin Layout & Pages
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminBookingEvents from './pages/AdminBookingEvents';
import AdminDisclaimers from './pages/AdminDisclaimers';
import AdminUsers from './pages/AdminUsers';
import AdminGalleryNew from './pages/AdminGalleryNew';
import AdminCheckIn from './pages/AdminCheckIn';
import AdminAuditLogs from './pages/AdminAuditLogs';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminLegalPages from './pages/AdminLegalPages';
import AdminEmailTemplates from './pages/AdminEmailTemplates';
import AdminBulkEmail from './pages/AdminBulkEmail';
import AdminStatistics from './pages/AdminStatistics';
import AdminSettings from './pages/AdminSettings';
import AdminMyAccount from './pages/admin/AdminMyAccount';

// Components
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/event/:eventId" element={<EventDetails />} />
            <Route path="/booking/success" element={<BookingSuccess />} />
            <Route path="/booking/cancel" element={<BookingCancel />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/general-rules" element={<GeneralRules />} />
            <Route path="/invite/:token" element={<InviteRedeem />} />
            
            {/* Admin Auth Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            
            {/* Admin Protected Routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="events" element={<AdminBookingEvents />} />
              <Route path="gallery" element={<AdminGalleryNew />} />
              <Route path="disclaimers" element={<AdminDisclaimers />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="check-in" element={<AdminCheckIn />} />
              <Route path="audit-logs" element={<AdminAuditLogs />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="legal-pages" element={<AdminLegalPages />} />
              <Route path="email-templates" element={<AdminEmailTemplates />} />
              <Route path="bulk-email" element={<AdminBulkEmail />} />
              <Route path="statistics" element={<AdminStatistics />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="my-account" element={<AdminMyAccount />} />
            </Route>
            
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <CookieConsent />
      </div>
    </AuthProvider>
  );
}

export default App;
